const GA_ID = import.meta.env.VITE_GA4_MEASUREMENT_ID;

declare global {
  interface Window {
    gtag: (...args: unknown[]) => void;
    dataLayer: unknown[];
  }
}

export function initAnalytics() {
  if (!GA_ID || import.meta.env.DEV) return;

  const script = document.createElement("script");
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  script.async = true;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function (...args: unknown[]) {
    window.dataLayer.push(args);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: true });
}

export function trackPageView(path: string, title: string) {
  if (!GA_ID || import.meta.env.DEV) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_title: title,
  });
}

export function trackEvent(
  name: string,
  params?: Record<string, string>
) {
  if (!GA_ID || import.meta.env.DEV) return;
  window.gtag("event", name, params);
}

/* ── Pre-defined event helpers ── */

export function trackCtaClick(location: string) {
  trackEvent("cta_click", { location });
}

export function trackSectionView(sectionId: string) {
  trackEvent("section_view", { section: sectionId });
}

export function trackFormOpen() {
  trackEvent("form_open");
}

export function trackFormSubmit(status: "success" | "error") {
  trackEvent("form_submit", { status });
}
